import ActionsMenu from "../../components/action-buttons/ActionsMenu";
import StatisticList from "./components/statistic-list/StatisticList";
import PresentationList from "./components/presentation-list/PresentationList";
import React from "react";
import {CalendarOutlined, MedicineBoxOutlined, RightOutlined} from "@ant-design/icons";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import {useGalleryController} from "../../controllers/gallery-controller";
import {useAuth} from "../../context/authContext";
import ReactSlickCarousel from "./components/reactSlick-carousel";
import ExternalLinksList from "../../components/externalLinks-list/ExternalLinksList";
import {Link} from "react-router-dom";
import * as RouteWays from "../../enums/routes";
import "./style.less"

const HomePage = () => {
  const galleryController = useGalleryController()
  const {canManageContent} = useAuth()

  return <div className="home-page">
    <main className="home-page__content">
      <section className="home-hero" aria-labelledby="home-hero-title">
        <ReactSlickCarousel galleryController={galleryController}/>
        <div className="home-hero__shade"/>
        <div className="home-hero__content">
          <div className="home-hero__eyebrow"><MedicineBoxOutlined/> Турбота поруч</div>
          <h1 className="home-hero__title" id="home-hero-title">Медицина, якій довіряють</h1>
          <p className="home-hero__description">
            Професійна медична допомога для жителів Близнюківської громади — уважно, відповідально та з повагою до кожного пацієнта.
          </p>
          <div className="home-hero__actions">
            <Link className="home-hero__primary-action" to={RouteWays.ADMISSION_SCHEDULE}>
              <CalendarOutlined/> Графік прийому
            </Link>
            <Link className="home-hero__secondary-action" to={RouteWays.DEPARTMENTS}>
              Наші відділення <RightOutlined/>
            </Link>
          </div>
        </div>
        {canManageContent && <div className="home-hero__admin-action">
          <ActionsMenu onEdit={galleryController.toggleGalleryModal}/>
        </div>}
      </section>

      <StatisticList/>
      <PresentationList/>
      <ExternalLinksList/>
    </main>
    <ScrollToTopButton elementSelector={".home-page__content"}/>
  </div>
}

export default HomePage
